import { FetchError } from "../errors/FetchError";
import { fetchWithAuthorization } from "./fetch";

export const fetchAccountPlans = async (condominiumId) => {
    try {
        const data = await fetchWithAuthorization(`/account-plans?condominium_id=${condominiumId}`);
        return data;
    } catch (error) {
        throw new FetchError(error, "Error al obtener el plan de cuentas");
    }
};

export const createAccountPlan = async (datas) => {
    try {
        const data = await fetchWithAuthorization("/account-plans", datas, "POST");
        return data;
    } catch (error) {
        throw new FetchError(error, "Error al crear la cuenta contable");
    }
};

export const updateAccountPlan = async (id, datas) => {
    try {
        const data = await fetchWithAuthorization(`/account-plans/${id}`, datas, "PUT");
        return data;
    } catch (error) {
        throw new FetchError(error, "Error al actualizar la cuenta contable");
    }
};

export const deleteAccountPlan = async (id) => {
    try {
        const data = await fetchWithAuthorization(`/account-plans/${id}`, null, "DELETE");
        return data;
    } catch (error) {
        throw new FetchError(error, "Error al eliminar la cuenta contable");
    }
};
